import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { CaseSession } from './caseSession';
import { ClaimType } from '../cases/claimType';
import { Expert } from './expert';
import { ExpertSession } from './expertSession';
import { PostponeCloseCause } from './postponeCloseCause';
import { SessionNote } from './sessionNote';
import { LawSuit } from './lawSuit';

@JsonObject('CaseSessionSearchResults')
export class CaseSessionSearchResults extends SearchResults {
    @JsonProperty('results', [CaseSession])
    results: CaseSession[] = [];
}

@JsonObject('ExpertSessionSearchResults')
export class ExpertSessionSearchResults extends SearchResults {
    @JsonProperty('results', [ExpertSession])
    results: ExpertSession[] = [];
}

@JsonObject('ExpertSearchResults')
export class ExpertSearchResults extends SearchResults {
    @JsonProperty('results', [Expert])
    results: Expert[] = [];
}

@JsonObject('CaseNoteSearchResults')
export class CaseNoteSearchResults extends SearchResults {
    @JsonProperty('results', [SessionNote])
    results: SessionNote[] = [];
}

@JsonObject('PostponeCauseSearchResults')
export class PostponeCauseSearchResults extends SearchResults {
    @JsonProperty('results', [PostponeCloseCause])
    results: PostponeCloseCause[] = [];
}

@JsonObject('SessionNoteSearchResults')
export class SessionNoteSearchResults extends SearchResults {
    @JsonProperty('results', [SessionNote])
    results: SessionNote[] = [];
}

@JsonObject('LawsuitSearchResults')
export class LawsuitSearchResults extends SearchResults {
    @JsonProperty('results', [LawSuit])
    results: LawSuit[] = [];
}